import { LinkedinOutlined, FacebookOutlined, InstagramOutlined, MailOutlined } from "@ant-design/icons";
import { Row, Col, Typography, Card } from "antd";
import BindeleddetLocationMap from "components/BindeleddetLocationMap/BindeleddetLocationMap";
import useViewport from "components/UseViewport/UseViewport";
import FAQcollapse from "containers/ContactUs/FAQcollapse/FAQcollapse";
import React from "react";

const { Title, Paragraph } = Typography;

const ContactUs = () => {
  const breakpoint = 768;

  const { width } = useViewport();

  return (
    <div style={{ maxWidth: "100vw", margin: 0, padding: 0 }}>
      <Row
        style={{
          justifyContent: "center",
          padding: width > breakpoint ? "48px" : "16px",
          maxWidth: "100%",
          margin: 0,
        }}
        gutter={[32, 32]}
      >
        <Col lg={16} xs={24}>
          <Title level={3}>Ofte stilte spørsmål</Title>
          <Card>
            <FAQcollapse />
          </Card>
        </Col>
        <Col lg={8} xs={24}>
          <Title level={3}>Kontaktinformasjon</Title>
          <Row gutter={[32, 32]}>
            <Col lg={24} md={12} sm={24}>
              <Card>
                <Paragraph>
                  <Title level={5}>Kontakt oss</Title>
                  <MailOutlined /> <a href="mailto:kontakt@bindeleddet.no">kontakt@bindeleddet.no</a>
                  <br />
                  <br />
                  <Title level={5}>Adresse</Title>
                  Kolbjørn Hejes vei 1E <br />
                  7034 Trondheim, Norge <br />
                  <br />
                  <Title level={5}>Tekniske problemer?</Title>
                  For spørsmål vedrørende nettsidene eller ved tekniske problemer, kontakt:{" "}
                  <a href="mailto:it@bindeleddet.no">it@bindeleddet.no</a>
                  <br />
                  <br />
                  <br />
                  <a href="https://www.facebook.com/bindeleddet.ntnu/?fref=ts">
                    <FacebookOutlined style={{ fontSize: "2em" }} />
                  </a>
                  <a href="https://www.instagram.com/bindeleddet/">
                    <InstagramOutlined style={{ fontSize: "2em", paddingLeft: "5%" }} />
                  </a>
                  <a href="https://www.linkedin.com/company/bindeleddet-ntnu">
                    <LinkedinOutlined style={{ fontSize: "2em", paddingLeft: "5%" }} />
                  </a>
                </Paragraph>
              </Card>
            </Col>
            <Col lg={24} md={12} sm={24} xs={24}>
              <Card>
                <BindeleddetLocationMap />
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default ContactUs;
